<template>
  <div class="tab-container">
    <VTextarea
      name="notes"
      label="Notes sur le talent"
      placeholder="Quelques notes personnelles sur ce talent..."
      rows="4"
      :maxlength="200"
      :modelValue="notes"
      @input="(event) => emits('updateNotes', event.target.value)"
      :disabled="campaignStore.currentCampaign.archived"
    />
  </div>
</template>

<script setup>
import { useCampaignStore } from "@/stores/campaign.js";

const campaignStore = useCampaignStore();

const emits = defineEmits(["updateNotes"]);

defineProps({
  notes: {
    type: [String, null],
    required: true,
  },
});
</script>
